import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Expenses from '../components/expenses/expense';
import * as ExpenseAction from '../actions/expenseAction';

function mapStateToProps(state) {
  return {
    ...state,
    expenses: state?.expense?.expenses,
    savedColumn: state?.expense?.savedColumn,
    userInfo: state.Chargecard.userInfo,
    filterQuery: state?.expense?.filterQuery || {},
    invoiceBulkSuccess: state.Invoice.invoiceBulkSuccess
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...ExpenseAction,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Expenses);
